var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5L3.77778 7.72222M3.77778 7.72222L10 1.5L16.2222 7.72222M3.77778 7.72222V16.6111C3.77778 17.102 4.17575 17.5 4.66667 17.5H7.33333M16.2222 7.72222L18 9.5M16.2222 7.72222V16.6111C16.2222 17.102 15.8243 17.5 15.3333 17.5H12.6667M7.33333 17.5C7.82425 17.5 8.22222 17.102 8.22222 16.6111V13.0556C8.22222 12.5646 8.62019 12.1667 9.11111 12.1667H10.8889C11.3798 12.1667 11.7778 12.5646 11.7778 13.0556V16.6111C11.7778 17.102 12.1757 17.5 12.6667 17.5M7.33333 17.5H12.6667",
    stroke: "#2667B0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconBlue);
export default __webpack_public_path__ + "static/media/home_icon_blue.f70b1e58a8577b27e390132884d5be6f.svg";
export { ForwardRef as ReactComponent };